import { observable, reaction } from 'mobx';
import { observer } from 'mobx-react';
import { PureComponent } from 'react';
import {
  ChartingLibraryWidgetOptions,
  IBasicDataFeed,
  IChartingLibraryWidget
} from '../../static/charting_library/charting_library.min';

import { formatDate } from 'web-utility';
import { EX3DataFeed, ExampleDataFeed } from './datafeed';

export interface TvProps {
  symbol: string;
  klineCanisterId: string;
  priceDecimals: number;
  baseTokenDecimals: number;
}

const timeButtons = [
  { text: '1min', resolution: '1' },
  { text: '5min', resolution: '5' },
  { text: '15min', resolution: '15' },
  { text: '30min', resolution: '30' },
  { text: '1hour', resolution: '60' },
  { text: '1day', resolution: '1D' },
  { text: '1week', resolution: '1W' },
  { text: '1mon', resolution: '1M' }
];
@observer
export class TVChartContainer extends PureComponent<TvProps> {
  @observable
  symbol = '';

  @observable
  symbolDisposer;

  @observable
  interval = '15';

  private dataFeed: IBasicDataFeed;
  private widget: IChartingLibraryWidget;
  componentDidMount() {
    this.symbolDisposer = reaction(
      () => {
        return {
          symbol: this.props.symbol || '',
          klineCanisterId: this.props?.klineCanisterId || '',
          tvWidget: window.TradingView
        };
      },
      p => {
        if (!p.symbol || !p.klineCanisterId || !p.tvWidget) return;

        if (this.dataFeed) this.dataFeed.unsubscribeBars('');

        if (this.symbol !== p.symbol && !!p.tvWidget) {
          this.dataFeed = new EX3DataFeed(
            p.klineCanisterId,
            this.props.priceDecimals,
            this.props.baseTokenDecimals
          );
          //this.dataFeed = new ExampleDataFeed();
          const widgetOptions: ChartingLibraryWidgetOptions = {
            debug: false,
            symbol: p.symbol,
            datafeed: this.dataFeed,
            interval: this.interval,
            container_id: 'tv_chart_container',
            library_path: 'charting_library/',
            locale: 'en',
            charts_storage_url: 'https://test.icp',
            charts_storage_api_version: '1.1',
            client_id: 'orderswap',
            user_id: 'dfinity',
            autosize: true,
            theme: 'Dark',
            toolbar_bg: '#111729',
            customFormatters: {
              //CustomFormatter
              timeFormatter: {
                format(date: Date): string {
                  return formatDate(date, 'HH:mm');
                },
                formatLocal(date: Date): string {
                  return formatDate(date, 'HH:mm');
                }
              },
              dateFormatter: {
                format(date: Date): string {
                  return formatDate(date, 'YYYY-MM-DD');
                },
                formatLocal(date: Date): string {
                  return formatDate(date, 'YYYY-MM-DD');
                }
              }
            },
            // custom_css_url: "bundles/custom.css",
            overrides: {
              'mainSeriesProperties.showCountdown': false,
              'paneProperties.background': '#111729',
              'mainSeriesProperties.candleStyle.upColor': '#0FBEAF',
              'mainSeriesProperties.candleStyle.downColor': '#EC4953',
              'paneProperties.vertGridProperties.color': '#131b2a',
              'paneProperties.horzGridProperties.color': '#131b2a',
              'scalesProperties.lineColor': '#252b3e'
            },
            disabled_features: [
              'use_localstorage_for_settings',
              'header_symbol_search',
              'symbol_search_hot_key',
              'border_around_the_chart',
              'pane_context_menu',
              'header_compare',
              'header_indicators',
              // "header_settings",
              'header_resolutions',
              'header_intervals',
              'header_screenshot',
              'header_chart_type',
              'header_chart_style',
              'header_fullscreen',
              'header_symbol_info',
              'header_undo_redo',
              'header_saveload',
              'timeframes_toolbar'
            ]
          };
          this.widget = new window.TradingView.widget(widgetOptions);
          const widget = this.widget;
          widget.onChartReady(() => {
            // widget
            //   .createButton({ align: 'left' })
            //   .addClass('custom-time-label')
            //   .text('Time');

            for (const { text, resolution } of timeButtons) {
              const button = widget.createButton();
              button
                .attr('title', text)
                .addClass('timeBtn')
                .text(text)
                .parent()
                .addClass('timeWrap');
              if (this.interval === resolution)
                button.css({ color: '#ffff' }).addClass('active');

              button.on('click', e => {
                if (e.srcElement.getAttribute('class').indexOf('active') !== -1)
                  return false;
                const timeWraps =
                  e.target.parentNode.parentNode.parentNode.querySelectorAll(
                    '.timeWrap'
                  );
                timeWraps.forEach(element => {
                  element.children[0].classList.remove('active');
                  element.children[0].setAttribute('style', '');
                });
                e.srcElement.classList.add('active');
                button.css({ color: '#ffff' });
                // @ts-ignore
                widget.chart().setResolution(resolution);
              });
            }
          });
          this.symbol = p.symbol;
        } else {
          console.debug(`trading view: ${p.symbol}, tvWidget: ${!!p.tvWidget}`);
        }
      },
      {
        fireImmediately: true
      }
    );
  }
  componentWillUnmount() {
    if (this.symbolDisposer) this.symbolDisposer();
  }
  render() {
    return (
      <div id="tv_chart_container" style={{ height: '100%', width: '100%' }} />
    );
  }
}
